import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { CartComponentStore } from 'cart-data';
import { ImageComponent } from 'common-ui';
import {
  ProductIdLabelComponent,
  ProductIsCanadianComponent,
  ProductNotReturnableViewComponent,
  ProductShortDescriptionComponent,
} from 'products-ui';
import { CartItemQuantitySelectorComponent } from '../../../../common/cart-item-quantity-selector';
import { RenderInCartItemResultLayoutDirective } from '../../../../layouts/cart-item/cart-item-result-layout/render-targets';
import { WireCutCartItemSummaryComponent } from '../../wire-cut-cart-item-summary';
import { WireCutCartItemResultLayoutComponentsProviderComponentBase } from '../WireCutCartItemResultLayoutComponentsProviderComponentBase';
import { ProductComponentStore } from 'products-data';

@Component({
  selector: 'ideal-wire-cut-cart-item-result-layout-components-provider',
  imports: [
    RenderInCartItemResultLayoutDirective,
    ImageComponent,
    ProductIdLabelComponent,
    ProductShortDescriptionComponent,
    ProductIsCanadianComponent,
    ProductNotReturnableViewComponent,
    // StandardCartItemSummaryComponent,
    CartItemQuantitySelectorComponent,
    WireCutCartItemSummaryComponent,
    JsonPipe,
  ],
  standalone: true,
  templateUrl: './wire-cut-cart-item-result-layout-components-provider.component.html',
  styleUrl: './wire-cut-cart-item-result-layout-components-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CartComponentStore, ProductComponentStore],
})
export class WireCutCartItemResultLayoutComponentsProviderComponent extends WireCutCartItemResultLayoutComponentsProviderComponentBase {
  // Regular wire items are always returnable; custom cuts never are.
  protected readonly isCustomCut = computed(() => this.id()?.options.has('Z') ?? false);
}
